export const PagamentoStato = Object.freeze({
  NON_AVVIATO: "NON_AVVIATO",
  IN_ATTESA: "IN_ATTESA",
  PAGATO: "PAGATO",
  FALLITO: "FALLITO",
  RIMBORSATO: "RIMBORSATO",
});

export const MetodoPagamento = Object.freeze({
  CARD: "CARD",
  PAYPAL: "PAYPAL",
  BONIFICO: "BONIFICO",
  CONTANTI_AL_RITIRO: "CONTANTI_AL_RITIRO",
});

export const pagamentoShape = {
  stato: PagamentoStato.NON_AVVIATO,
  metodo: null,
  transactionId: null,
  totale: 0,
  valuta: "EUR",
};

export const createPagamentoModel = (overrides = {}) => ({
  ...pagamentoShape,
  ...overrides,
});

